<mat-dialog-content data-testId="message-dialog-content" class="message"> {{ data }} </mat-dialog-content>
<mat-dialog-actions align="end">
  <button data-testId="message-dialog-close-button" mat-stroked-button mat-dialog-close color="basic">Close</button>
</mat-dialog-actions>
